export const RULE_GRAPH_FIT_PADDING = 0.16;
